// extracted by mini-css-extract-plugin
export var caretAnchor = "_ud-0";
export var dropdownContent = "_ud-1";